module.exports = __webpack_public_path__ + "static/img/drive.2d27966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/screenshots/drive.png
// module id = P41T
// module chunks = 0